import script from "./ClientForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClientForm.vue?vue&type=script&lang=ts&setup=true"

import "./ClientForm.vue?vue&type=style&index=0&id=0e61b678&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/bookonline/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e61b678"]])

export default __exports__